// extracted by mini-css-extract-plugin
export default {"brandPromo":"wG-z","carousel":"xG-z"};